import { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import axiosInstance from "../../api/axiosInstance";
import "./notifications.scss";
import moment from "moment";

function Notifications({ onUnreadChange }) {
    const [notifications, setNotifications] = useState([]);
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    const loadNotifications = useCallback(async (showLoading = false) => {
        try {
            if (showLoading) setLoading(true);

            const response = await axiosInstance.get("notifications");

            const data = response.data.notifications;
            setNotifications(data);

            onUnreadChange?.(
                data.filter(
                    (notification) => Number(notification.isRead) === 0
                ).length
            );
        } catch (error) {
            console.error(
                "Fehler beim Laden der Benachrichtigungen:",
                error
            );
        } finally {
            if (showLoading) setLoading(false);
        }
    }, [onUnreadChange]);

    useEffect(() => {
        loadNotifications(true);

        const interval = setInterval(() => {
            loadNotifications();
        }, 30000);

        return () => clearInterval(interval);
    }, [loadNotifications]);

    const handleNotificationClick = async (notification) => {
        try {
            if (Number(notification.isRead) === 0) {
                await axiosInstance.patch(
                    `notifications/${notification.id}/read`
                );

                setNotifications((previous) => {
                    const updated = previous.map((item) =>
                        item.id === notification.id
                            ? { ...item, isRead: 1 }
                            : item
                    );

                    onUnreadChange?.(
                        updated.filter(
                            (item) => Number(item.isRead) === 0
                        ).length
                    );

                    return updated;
                });
            }

            if (notification.link) {
                navigate(notification.link);
            }
        } catch (error) {
            console.error(
                "Fehler beim Aktualisieren der Benachrichtigung:",
                error
            );
        }
    };

    if (loading) {
        return (
            <div className="notificationList">
                <div className="loading" />
            </div>
        );
    }

    return (
        <div className="notificationList">
            <h5 className="heading">Benachrichtigungen</h5>
            <hr />
            <div className="scroll">
                <div className="list">
                    {notifications.length === 0 ? (
                        <div className="notificationEmpty">
                            Keine Benachrichtigungen
                        </div>
                    ) : (
                        notifications.map((notification) => (
                            <div
                                key={notification.id}
                                className="notificationItem"
                                onClick={() => handleNotificationClick(notification)}
                            >
                                <div className="top">
                                    <h5 className="title">{notification.title}</h5>

                                    {Number(notification.isRead) === 0 && (
                                        <div className="dot" />
                                    )}
                                </div>

                                <p className="message">{notification.message}</p>

                                <span className="date">
                                    {moment(notification.createdAt).fromNow()}
                                </span>
                            </div>
                        ))
                    )}
                </div>
            </div>
        </div>
    );
}

export default Notifications;